import { lazy } from 'react';
import i18next from 'i18next';
import { AlertsIcon } from '@shared/ui/icons';

const AlertList = lazy(() => import('@pages/alerts'));

const ALERT_ROUTE_LIST = {
  path: ':currentAccountUuid/alerts',
  exact: true,
  additional: {
    component: AlertList,
    protected: true,
    title: i18next.t('titles:alerts'),
    icon: AlertsIcon,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.alerts || 'Alerts',
    },
  },
};

export const ALERT_ROUTES = {
  // ------- For child accounts ------
  // ...

  // ------- For current accounts ------
  list: ALERT_ROUTE_LIST,
};
